function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M7 0.5C3.15 0.5 0 3.65 0 7.5C0 11.35 3.15 14.5 7 14.5C10.85 14.5 14 11.35 14 7.5C14 3.65 10.85 0.5 7 0.5ZM7 11C6.475 11 6.125 10.65 6.125 10.125C6.125 9.6 6.475 9.25 7 9.25C7.525 9.25 7.875 9.6 7.875 10.125C7.875 10.65 7.525 11 7 11ZM7.875 8.375H6.125V4H7.875V8.375Z",
  fill: "#EC2B00"
});

const SvgRejectStatusSolid = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgRejectStatusSolid, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/reject_status_solid.bf245dfc.svg";
export { ForwardRef as ReactComponent };